import React, { FC } from 'react';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as translations from './strings';
import { getLangKey } from '../../../../models/Language';
import { DatePicker } from 'antd';
import DetailsLabel from '../DetailsLabel';
import styles from './styles.module.css';
import cx from 'classnames';
import { isMobile } from 'react-device-detect';
dayjs.extend(utc);

const strings = translations[getLangKey()];

type Props = {
  dueDate: string;
  canEditDueDate: boolean;
  updateDueDate: (value?: string) => void;
  hideDivider?: boolean;
};

const DueDate: FC<Props> = ({
  dueDate,
  updateDueDate,
  canEditDueDate,
  hideDivider
}) => {
  const handleOnChange = (date: dayjs.Dayjs) => {
    updateDueDate(date ? date.utc().toISOString() : '');
  };

  return (
    <div
      className={cx(styles.dueDateOuter, { [styles.noDivider]: hideDivider })}
    >
      <DetailsLabel label={strings.dueDate} />
      {/*// @ts-ignore*/}
      <DatePicker
        inputReadOnly={isMobile}
        value={dueDate ? dayjs(dueDate) : null}
        format="D MMM YYYY"
        onChange={handleOnChange}
        disabled={!canEditDueDate}
        getPopupContainer={trigger => trigger.parentElement}
        className={styles.datePicker}
      />
    </div>
  );
};

export default DueDate;
